// extracted by mini-css-extract-plugin
export default {"container":"AtsBanner_container__NbYy3","image":"AtsBanner_image__PQruf","skeleton":"AtsBanner_skeleton__b1l50"};